module.exports = __webpack_public_path__ + "static/media/Tick-Box-Active-Read-Only.0d271923.svg";